import { BaseComponent } from '../../base-component';

export class KuvoCinemaComponent extends BaseComponent {
    public rootSelector = '.js_pdp_kuvo-cinema';

    public async init(): Promise<unknown> {
        return;
    }

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        o_global.eventQBus.emit('ft9.benefit.init');
    }
}
